import { getDraftListApi } from '@/api/lauchApproval';
export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: [],
    filter: {}
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    getTableInfo ({ commit, dispatch, state }, { filter }) {
      const pasFilter = { ...filter };
      getDraftListApi(pasFilter).then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          commit('SAVE_STATE', { dataSource: data.records, totalCount: data.total, filter });
        }
      });
    }
  }
};
